import globalMedevac from '@/assets/oap/global_medevac_logo.png'
import inman from '@/assets/oap/inman_logo.svg'
import masa from '@/assets/oap/masa_logo.svg'
import sepioGuard from '@/assets/oap/sepio_guard_logo.png'

export enum OapProvider {
	MASA = 'MASA',
	SEPIO_GUARD = 'Sepio Guard',
	GLOBAL_MEDEVAC = 'Global Medevac',
	INMAN = 'Inman',
}

export interface OapProviderData {
	name: OapProvider
	imageUrl: string
}

export interface OapContract {
	carrier: OapProvider
	price: number
	status: 'Active' | 'Inactive'
}

export type OapDetails = OapProviderData &
	OapContract & {
		status: 'Active'
	}

export const oapProviders: Record<OapProvider, OapProviderData> = {
	[OapProvider.MASA]: {
		name: OapProvider.MASA,
		imageUrl: masa,
	},
	[OapProvider.SEPIO_GUARD]: {
		name: OapProvider.SEPIO_GUARD,
		imageUrl: sepioGuard,
	},
	[OapProvider.GLOBAL_MEDEVAC]: {
		name: OapProvider.GLOBAL_MEDEVAC,
		imageUrl: globalMedevac,
	},
	[OapProvider.INMAN]: {
		name: OapProvider.INMAN,
		imageUrl: inman,
	},
}
